window.EmployeeClockStatsAPI =  new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI("EmployeeClockStats"));

    self.getUsersAverageTotalHours = function (brandId, payload) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/users/weeks/average_total_hours', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {

                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getUsersWorkedDays = function (brandId, payload) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/users/weeks/totals', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            })
            .catch(function (err) {
                console.error(err);
                defer.resolve([]);
            });

        return defer.promise;
    };

    self.getScheduledUsersFirstPublishTime = function (brandId, payload) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/users/first_publish', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            })
            .catch(function (err) {
                console.error(err);
                defer.resolve([]);
            });

        return defer.promise;
    };

};